import { render, staticRenderFns } from "./activity-3.vue?vue&type=template&id=1013aba6&scoped=true&"
import script from "./activity-3.vue?vue&type=script&lang=js&"
export * from "./activity-3.vue?vue&type=script&lang=js&"
import style0 from "./activity-3.vue?vue&type=style&index=0&id=1013aba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1013aba6",
  null
  
)

export default component.exports